import React from "react";
import { useTranslation } from "react-i18next";
import { formatDateTime } from "./scheduleUtils";
import "./Modal.css";

const RideModal = ({ ride, onClose }) => {
  const { t } = useTranslation();
  if (!ride) return null;
  return (
    <div className="dispatch-modal-backdrop" onClick={onClose}>
      <div className="dispatch-modal" onClick={(e) => e.stopPropagation()}>
        <div className="dispatch-modal-header">
          <span className="dispatch-modal-title">
            {t("ORDER_NUMBER")}: {ride.order_number || "—"}
          </span>
          <button className="dispatch-modal-close" onClick={onClose}>×</button>
        </div>
        <div className="dispatch-modal-body">
          <div className="dispatch-modal-row">
            <span className="dispatch-modal-label">{t("STATUS")}</span>
            <span>{ride.status || "—"}</span>
          </div>
          <div className="dispatch-modal-row">
            <span className="dispatch-modal-label">{t("CUSTOMER_PHONE")}</span>
            <span>{ride.customer_phone || "—"}</span>
          </div>
          <div className="dispatch-modal-row">
            <span className="dispatch-modal-label">{t("ONSITE_DATE")}</span>
            <span>{formatDateTime(ride.desired_onsite_datetime)}</span>
          </div>
          {ride.note && (
            <div className="dispatch-modal-row">
              <span className="dispatch-modal-label">{t("NOTE")}</span>
              <span>{ride.note}</span>
            </div>
          )}
        </div>
        {ride.tracking_id && (
          <div className="dispatch-modal-footer">
            <button
              className="dispatch-modal-track-btn"
              onClick={() => window.open(`/live_tracker?tracking_id=${ride.tracking_id}`, "_blank")}
            >
              {t("TRACK_DELIVERY")}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default RideModal;
